/**
 *  @class
 *  @function ShopTheLook
 */
if (!customElements.get("shop-the-look")) {
  class ShopTheLook extends HTMLElement {
    constructor() {
      super();
    }
  }
  customElements.define("shop-the-look", ShopTheLook);
}
